webpackJsonp([131],{

/***/ 1166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignReviewPage_vue__ = __webpack_require__(2837);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a32917a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignReviewPage_vue__ = __webpack_require__(4810);
function injectStyle (ssrContext) {
  __webpack_require__(4800)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a32917a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignReviewPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a32917a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignReviewPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(22);


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(12);
var LIBRARY = __webpack_require__(104);
var wksExt = __webpack_require__(1350);
var defineProperty = __webpack_require__(54).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(244);
var hiddenKeys = __webpack_require__(148).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1365);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1366);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1368), __esModule: true };

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1369), __esModule: true };

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(235);
var createDesc = __webpack_require__(103);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var has = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(243);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(234);
module.exports = __webpack_require__(1350).f('iterator');


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1370);
__webpack_require__(241);
__webpack_require__(1373);
__webpack_require__(1374);
module.exports = __webpack_require__(12).Symbol;


/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(40);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(245);
var META = __webpack_require__(1353).KEY;
var $fails = __webpack_require__(76);
var shared = __webpack_require__(147);
var setToStringTag = __webpack_require__(105);
var uid = __webpack_require__(144);
var wks = __webpack_require__(22);
var wksExt = __webpack_require__(1350);
var wksDefine = __webpack_require__(1351);
var enumKeys = __webpack_require__(1371);
var isArray = __webpack_require__(1356);
var anObject = __webpack_require__(41);
var isObject = __webpack_require__(55);
var toObject = __webpack_require__(78);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var createDesc = __webpack_require__(103);
var _create = __webpack_require__(240);
var gOPNExt = __webpack_require__(1372);
var $GOPD = __webpack_require__(1367);
var $GOPS = __webpack_require__(237);
var $DP = __webpack_require__(54);
var $keys = __webpack_require__(101);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(1354).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(235).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(104)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(237);
var pIE = __webpack_require__(235);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(100);
var gOPN = __webpack_require__(1354).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('asyncIterator');


/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('observable');


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 1514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TaskDescButton'
});

/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDescButton_vue__ = __webpack_require__(1514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc218e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDescButton_vue__ = __webpack_require__(1558);
function injectStyle (ssrContext) {
  __webpack_require__(1556)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbc218e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDescButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc218e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDescButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1557);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("39328c12", content, true, {});

/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TaskDescButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticStyle:{"position":"absolute","right":"200px","bottom":"18px","color":"red"},attrs:{"href":"https://slicejobs-tech.feishu.cn/wiki/IFSEwU6zhi3fetk53uScDxFPnwh","target":"_blank"}},[_vm._v("查看任务&工单&证据归档说明\n  ")]),_vm._v(" "),_c('a',{staticStyle:{"position":"absolute","right":"10px","bottom":"18px"},attrs:{"href":"http://img-cn-shanghai.aliyuncs.com/taskdesc/190603/50/ad816a4cf26d21609f15540fa701c174.png","target":"_blank"}},[_vm._v("查看任务&工单&零工说明\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_task_components_buttons_TaskDescButton__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_order_components_SourceAllocationPanel_vue__ = __webpack_require__(4802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_order_components_ReviewerAssignPanel_vue__ = __webpack_require__(4806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_order_order_api__ = __webpack_require__(153);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssignReviewPage',
  components: {
    TaskDescButton: __WEBPACK_IMPORTED_MODULE_1__views_task_components_buttons_TaskDescButton__["a" /* default */],
    SourceAllocationPanel: __WEBPACK_IMPORTED_MODULE_2__views_order_components_SourceAllocationPanel_vue__["a" /* default */],
    ReviewerAssignPanel: __WEBPACK_IMPORTED_MODULE_3__views_order_components_ReviewerAssignPanel_vue__["a" /* default */]
  },
  data: function data() {
    return {
      quickForm: {
        reviewTarget: '',
        sampleRate: ''
      },
      totalExpected: 0,
      reviewTargetDate: '',
      submitting: false
    };
  },

  methods: {
    onQuickSampleRateInput: function onQuickSampleRateInput() {
      var raw = String(this.quickForm.sampleRate || '').replace(/\D/g, '').slice(0, 3);
      if (raw === '') {
        this.quickForm.sampleRate = '';
      } else {
        var num = Math.min(100, Math.max(0, parseInt(raw, 10) || 0));
        this.quickForm.sampleRate = String(num);
      }
    },
    applyQuickSettings: function applyQuickSettings() {
      var target = this.quickForm.reviewTarget;
      var rate = this.quickForm.sampleRate;
      if (target !== '') {
        var panel = this.$refs.reviewerPanel;
        if (panel && panel.setAssignedCount) {
          panel.setAssignedCount(target);
        }
      }
      if (rate !== '') {
        var _panel = this.$refs.sourcePanel;
        if (_panel && _panel.applySampleRate) {
          _panel.applySampleRate(rate);
        }
      }
    },
    onCancel: function onCancel() {
      this.$router.go(-1);
    },

    // 组装确认分配请求数据：searchParams(路由参数) + 来源分配(实习生ID,预计) + 复核分配(复核人ID,复核单量)
    getConfirmAssignPayload: function getConfirmAssignPayload() {
      var query = this.$route.query || {};
      var searchParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, query);

      var sourcePanel = this.$refs.sourcePanel;
      var internList = sourcePanel && sourcePanel.internList ? sourcePanel.internList : [];
      var sourceAllocation = internList.map(function (row) {
        return {
          intern_user_id: row.intern_user_id != null ? row.intern_user_id : row.id,
          expected: Number(row.expected) || 0
        };
      });

      var reviewerPanel = this.$refs.reviewerPanel;
      var reviewerList = reviewerPanel && reviewerPanel.reviewerList ? reviewerPanel.reviewerList : [];
      var reviewAssignment = reviewerList.map(function (row) {
        return {
          reviewer_id: row.id,
          adminname: row.name != null ? String(row.name) : '',
          assigned_count: Number(row.assignedCount) || 0
        };
      });

      return {
        searchParams: searchParams,
        source_allocation: sourceAllocation,
        review_assignment: reviewAssignment
      };
    },
    onConfirmAssign: function onConfirmAssign() {
      var _this = this;

      var reviewerPanel = this.$refs.reviewerPanel;
      var reviewerList = reviewerPanel ? reviewerPanel.reviewerList : [];
      if (reviewerList.length === 0) {
        this.$message.warning('请至少添加一名复核人');
        return;
      }
      var totalAssignedCount = reviewerPanel ? reviewerPanel.totalAssignedCount : 0;
      if (totalAssignedCount <= 0) {
        this.$message.warning('复核单量必须大于0');
        return;
      }
      if (totalAssignedCount > this.totalExpected) {
        this.$message.warning('复核单量总计不能超过预计总计');
        return;
      }
      var payload = this.getConfirmAssignPayload();
      this.submitting = true;
      Object(__WEBPACK_IMPORTED_MODULE_4__views_order_order_api__["submitTaskAssignment"])(payload).then(function () {
        _this.$message.success('分配成功');
        _this.$router.go(-1);
      }).catch(function (err) {
        var msg = err && err.response && err.response.data && err.response.data.message || err && err.message || '分配失败';
        _this.$message.error(msg);
      }).finally(function () {
        _this.submitting = false;
      });
    }
  }
});

/***/ }),

/***/ 2838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_order_order_api__ = __webpack_require__(153);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SourceAllocationPanel',
  props: {
    // 从列表页跳转时携带的检索参数（如 mode、orderid、projectid 等）
    queryParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      internList: [],
      loading: false
    };
  },

  computed: {
    totalExpected: function totalExpected() {
      return this.internList.reduce(function (sum, row) {
        return sum + (Number(row.expected) || 0);
      }, 0);
    }
  },
  watch: {
    totalExpected: {
      handler: function handler(val) {
        this.$emit('total-expected', val);
      },

      immediate: true
    },
    queryParams: {
      handler: function handler() {
        this.fetchInternList();
      },

      deep: true
    }
  },
  created: function created() {
    this.fetchInternList();
  },

  methods: {
    fetchInternList: function fetchInternList() {
      var _this = this;

      this.loading = true;
      var params = this.queryParams && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.queryParams) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.queryParams) : {};
      Object(__WEBPACK_IMPORTED_MODULE_2__views_order_order_api__["getPendingReviewTaskStats"])(params).then(function (res) {
        var detail = res && res.data && res.data.detail;
        _this.internList = Array.isArray(detail) ? detail : [];
        _this.internList.forEach(function (row) {
          return _this.calcInternExpected(row);
        });
      }).catch(function () {
        _this.internList = [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    applySampleRate: function applySampleRate(rate) {
      var _this2 = this;

      if (rate === '' || rate == null) return;
      var clamped = Math.min(100, Math.max(0, Number(rate) || 0));
      this.internList.forEach(function (row) {
        row.sampleRate = String(clamped);
        _this2.calcInternExpected(row);
      });
    },
    onInternSampleRateChange: function onInternSampleRateChange(row) {
      var raw = String(row.sampleRate || '').replace(/\D/g, '').slice(0, 3);
      if (raw === '') {
        row.sampleRate = '';
      } else {
        var num = Math.min(100, Math.max(0, parseInt(raw, 10) || 0));
        row.sampleRate = String(num);
      }
      this.calcInternExpected(row);
    },

    // 预计(向下取整)=总单量*抽检比例；抽检比例=0则预计=0；抽检比例>0但预计<1则预计=1
    calcInternExpected: function calcInternExpected(row) {
      var total = Number(row.totalCount != null ? row.totalCount : row.count) || 0;
      var rate = Number(row.sampleRate) || 0;
      if (rate === 0) {
        this.$set(row, 'expected', 0);
        return;
      }
      var val = Math.floor(total * rate / 100);
      this.$set(row, 'expected', val < 1 ? 1 : val);
    },
    removeIntern: function removeIntern(index) {
      this.internList.splice(index, 1);
    }
  }
});

/***/ }),

/***/ 2839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_platform_user_platform_user_api__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_order_order_api__ = __webpack_require__(153);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReviewerAssignPanel',
  props: {
    totalExpected: {
      type: Number,
      default: 0
    },
    reviewTargetDate: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      reviewerList: [],
      addReviewerDialogVisible: false,
      selectedReviewerInDialog: []
    };
  },

  computed: {
    totalAssignedCount: function totalAssignedCount() {
      return this.reviewerList.reduce(function (sum, row) {
        return sum + (Number(row.assignedCount) || 0);
      }, 0);
    },
    totalTarget: function totalTarget() {
      return this.reviewerList.reduce(function (sum, row) {
        return sum + (Number(row.target) || 0);
      }, 0);
    },
    reviewTargetColumnLabel: function reviewTargetColumnLabel() {
      var date = this.reviewTargetDate || '';
      var base = date ? '\u590D\u6838\u76EE\u6807(' + date + ')' : '复核目标';
      return base + '(\u603B\u8BA1' + this.totalTarget + ')';
    },

    /** 实际分配合计 − 预计单量合计；0 为一致 */
    assignDiff: function assignDiff() {
      return this.totalAssignedCount - (Number(this.totalExpected) || 0);
    },
    assignDiffDisplay: function assignDiffDisplay() {
      var d = this.assignDiff;
      if (d === 0) return '0';
      return d > 0 ? '+' + d : String(d);
    }
  },
  methods: {
    /** 按当前「预计单量合计」在复核人之间平均整数分配（除不尽时余数归最后一人） */
    applyAverageDistribution: function applyAverageDistribution() {
      var _this = this;

      var n = this.reviewerList.length;
      if (n === 0) {
        this.$message.warning('请先添加复核人');
        return;
      }
      var total = Math.max(0, Math.floor(Number(this.totalExpected) || 0));
      var base = Math.floor(total / n);
      var rem = total % n;
      this.reviewerList.forEach(function (row, i) {
        var val = i === n - 1 ? base + rem : base;
        _this.$set(row, 'assignedCount', String(val));
      });
      this.$message.success('已按预计单量平均分配复核单量');
    },
    setAssignedCount: function setAssignedCount(target) {
      var _this2 = this;

      if (target === '' || target == null) return;
      var raw = String(target).replace(/\D/g, '');
      var val = raw === '' ? '' : String(parseInt(raw, 10) || 0);
      this.reviewerList.forEach(function (row) {
        _this2.$set(row, 'assignedCount', val);
      });
    },
    removeReviewer: function removeReviewer(index) {
      this.reviewerList.splice(index, 1);
    },
    onReviewerAssignedChange: function onReviewerAssignedChange(row) {
      var raw = String(row.assignedCount != null ? row.assignedCount : '').replace(/\D/g, '');
      this.$set(row, 'assignedCount', raw === '' ? '' : raw);
    },
    openAddReviewerDialog: function openAddReviewerDialog() {
      this.addReviewerDialogVisible = true;
    },
    onAddReviewerDialogOpen: function onAddReviewerDialogOpen() {
      this.selectedReviewerInDialog = [];
    },
    onAddReviewerDialogClosed: function onAddReviewerDialogClosed() {
      this.selectedReviewerInDialog = [];
    },
    queryPlatformUsers: function queryPlatformUsers(params) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_platform_user_platform_user_api__["getPlatformUsersIndex"])(params || {}).then(function (res) {
        var body = res && res.data;
        var list = [];
        if (body && body.detail && Array.isArray(body.detail.data)) {
          list = body.detail.data;
        } else if (body && Array.isArray(body.data)) {
          list = body.data;
        }
        return { data: { data: list } };
      });
    },
    findPlatformUser: function findPlatformUser(params) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_platform_user_platform_user_api__["getPlatformUsersDetail"])(params || {});
    },
    getPlanDateToday: function getPlanDateToday() {
      var d = new Date();
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + day;
    },
    parseReviewPlanTarget: function parseReviewPlanTarget(res) {
      if (!res || res.data == null) return 0;
      var data = res.data;
      if (data.target != null && data.target !== '') {
        var n = Number(data.target);
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(n) ? 0 : n;
      }
      var detail = data.detail;
      if (Array.isArray(detail)) {
        if (detail.length === 0) return 0;
        return detail.reduce(function (sum, row) {
          if (!row || row.review_target == null || row.review_target === '') return sum;
          var n = Number(row.review_target);
          return sum + (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(n) ? 0 : n);
        }, 0);
      }
      if (detail && (typeof detail === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(detail)) === 'object' && detail.target != null) {
        var _n = Number(detail.target);
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(_n) ? 0 : _n;
      }
      return 0;
    },
    confirmAddReviewer: function confirmAddReviewer() {
      var _this3 = this;

      var raw = this.selectedReviewerInDialog;
      var ids = Array.isArray(raw) ? raw : raw != null ? [raw] : [];
      var selectedIds = ids.map(function (item) {
        return item != null && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(item)) === 'object' && item.id != null ? item.id : item;
      }).filter(function (id) {
        return id != null && id !== '';
      });
      if (selectedIds.length === 0) {
        this.addReviewerDialogVisible = false;
        return;
      }
      var existingIds = this.reviewerList.map(function (r) {
        return r.id;
      }).filter(Boolean);
      var toAddIds = selectedIds.filter(function (id) {
        return existingIds.indexOf(id) === -1;
      });
      if (toAddIds.length === 0) {
        this.$message.warning('所选用户已在复核人列表中');
        this.addReviewerDialogVisible = false;
        return;
      }
      var planDate = this.getPlanDateToday();
      var promises = toAddIds.map(function (id) {
        var detailPromise = Object(__WEBPACK_IMPORTED_MODULE_4__views_platform_user_platform_user_api__["getPlatformUsersDetail"])({ id: id }).then(function (res) {
          var data = res && res.data;
          var name = data && data.name || data && data.detail && data.detail.name || data && data.data && data.data.name || data && data.detail && data.detail.data && data.detail.data.name;
          return name != null && name !== '' ? String(name) : '-';
        }).catch(function () {
          return String(id);
        });
        var planPromise = Object(__WEBPACK_IMPORTED_MODULE_5__views_order_order_api__["getReviewPlanQuery"])({ admin_id: id, plan_date: planDate }).then(function (res) {
          return _this3.parseReviewPlanTarget(res);
        }).catch(function () {
          return 0;
        });
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([detailPromise, planPromise]).then(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              name = _ref2[0],
              target = _ref2[1];

          return {
            id: id,
            name: name,
            target: target,
            assignedCount: ''
          };
        });
      });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function (users) {
        users.forEach(function (u) {
          _this3.reviewerList.push({
            id: u.id,
            name: u.name,
            target: u.target,
            assignedCount: u.assignedCount
          });
        });
        _this3.addReviewerDialogVisible = false;
        _this3.selectedReviewerInDialog = [];
      });
    }
  }
});

/***/ }),

/***/ 4800:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4801);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("06fea291", content, true, {});

/***/ }),

/***/ 4801:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".assign-review-page[data-v-a32917a4]{padding-bottom:40px}.page-heading[data-v-a32917a4]{margin-bottom:16px}.quick-actions[data-v-a32917a4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px 16px;padding:12px 16px;margin-bottom:16px;background:#fdf6ec;border:1px solid #f5d9b8;border-radius:4px}.quick-actions .quick-label[data-v-a32917a4]{color:#606266;font-size:14px}.quick-actions .quick-input.quick-input-rate[data-v-a32917a4],.quick-actions .quick-input[data-v-a32917a4]{width:180px}.layout-panel[data-v-a32917a4]{margin-bottom:16px}.page-actions[data-v-a32917a4]{margin-top:24px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px}", "", {"version":3,"sources":["/workspace/src/views/order/pages/AssignReviewPage.vue"],"names":[],"mappings":"AACA,qCAAqC,mBAAmB,CACvD,AACD,+BAA+B,kBAAkB,CAChD,AACD,gCAAgC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,mBAAmB,eAAe,aAAa,kBAAkB,mBAAmB,mBAAmB,yBAAyB,iBAAiB,CACvS,AACD,6CAA6C,cAAc,cAAc,CACxE,AAGD,2GAA8D,WAAW,CACxE,AACD,+BAA+B,kBAAkB,CAChD,AACD,+BAA+B,gBAAgB,oBAAoB,oBAAoB,aAAa,QAAQ,CAC3G","file":"AssignReviewPage.vue","sourcesContent":["\n.assign-review-page[data-v-a32917a4]{padding-bottom:40px\n}\n.page-heading[data-v-a32917a4]{margin-bottom:16px\n}\n.quick-actions[data-v-a32917a4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px 16px;padding:12px 16px;margin-bottom:16px;background:#fdf6ec;border:1px solid #f5d9b8;border-radius:4px\n}\n.quick-actions .quick-label[data-v-a32917a4]{color:#606266;font-size:14px\n}\n.quick-actions .quick-input[data-v-a32917a4]{width:180px\n}\n.quick-actions .quick-input.quick-input-rate[data-v-a32917a4]{width:180px\n}\n.layout-panel[data-v-a32917a4]{margin-bottom:16px\n}\n.page-actions[data-v-a32917a4]{margin-top:24px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SourceAllocationPanel_vue__ = __webpack_require__(2838);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_607c5e06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SourceAllocationPanel_vue__ = __webpack_require__(4805);
function injectStyle (ssrContext) {
  __webpack_require__(4803)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-607c5e06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SourceAllocationPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_607c5e06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SourceAllocationPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4803:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4804);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6e7825c9", content, true, {});

/***/ }),

/***/ 4804:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".sample-rate-input[data-v-607c5e06] input[type=number]::-webkit-inner-spin-button,.sample-rate-input[data-v-607c5e06] input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.sample-rate-input[data-v-607c5e06] input[type=number]{-moz-appearance:textfield}", "", {"version":3,"sources":["/workspace/src/views/order/components/SourceAllocationPanel.vue"],"names":[],"mappings":"AACA,oKAAwK,wBAAwB,QAAQ,CACvM,AACD,uDAAyD,yBAAyB,CACjF","file":"SourceAllocationPanel.vue","sourcesContent":["\n.sample-rate-input[data-v-607c5e06] input[type='number']::-webkit-outer-spin-button,.sample-rate-input[data-v-607c5e06] input[type='number']::-webkit-inner-spin-button{-webkit-appearance:none;margin:0\n}\n.sample-rate-input[data-v-607c5e06] input[type='number']{-moz-appearance:textfield\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-panel',[_c('template',{slot:"header"},[_vm._v("1. 来源分配 & 抽检比例")]),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.internList,"stripe":"","border":""}},[_c('el-table-column',{attrs:{"label":"实习生ID","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.intern_user_id != null ? scope.row.intern_user_id : (scope.row.id != null ? scope.row.id : '-'))+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"实习生"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"count","label":"总单量","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"抽检比例","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticClass:"sample-rate-input",attrs:{"type":"number","size":"small","placeholder":"","min":"0","max":"100","step":"1"},on:{"input":function($event){return _vm.onInternSampleRateChange(scope.row)}},model:{value:(scope.row.sampleRate),callback:function ($$v) {_vm.$set(scope.row, "sampleRate", $$v)},expression:"scope.row.sampleRate"}},[_c('template',{slot:"append"},[_vm._v("%")])],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":("预计(总计" + _vm.totalExpected + ")"),"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.expected != null ? scope.row.expected : 0)+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.removeIntern(scope.$index)}}},[_vm._v("移除")])]}}])})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewerAssignPanel_vue__ = __webpack_require__(2839);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c036f05a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewerAssignPanel_vue__ = __webpack_require__(4809);
function injectStyle (ssrContext) {
  __webpack_require__(4807)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c036f05a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewerAssignPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c036f05a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewerAssignPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4807:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4808);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1ffe2bf3", content, true, {});

/***/ }),

/***/ 4808:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".assign-diff-bar[data-v-c036f05a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px 20px;padding:10px 12px;margin-bottom:12px;background:#f4f4f5;border-radius:4px;font-size:13px;color:#606266}.assign-diff-bar .assign-diff-item strong[data-v-c036f05a]{color:#303133;font-weight:600}.reviewer-toolbar[data-v-c036f05a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.dialog-select-width[data-v-c036f05a]{width:100%}.add-reviewer-dialog[data-v-c036f05a] .el-dialog__body{padding:24px 28px 28px}", "", {"version":3,"sources":["/workspace/src/views/order/components/ReviewerAssignPanel.vue"],"names":[],"mappings":"AACA,kCAAkC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,yBAAyB,sBAAsB,mBAAmB,aAAa,kBAAkB,mBAAmB,mBAAmB,kBAAkB,eAAe,aAAa,CAC7S,AACD,2DAA2D,cAAc,eAAe,CACvF,AACD,mCAAmC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,QAAQ,yBAAyB,sBAAsB,kBAAkB,CAClM,AACD,sCAAsC,UAAU,CAC/C,AACD,uDAAuD,sBAAsB,CAC5E","file":"ReviewerAssignPanel.vue","sourcesContent":["\n.assign-diff-bar[data-v-c036f05a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px 20px;padding:10px 12px;margin-bottom:12px;background:#f4f4f5;border-radius:4px;font-size:13px;color:#606266\n}\n.assign-diff-bar .assign-diff-item strong[data-v-c036f05a]{color:#303133;font-weight:600\n}\n.reviewer-toolbar[data-v-c036f05a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.dialog-select-width[data-v-c036f05a]{width:100%\n}\n.add-reviewer-dialog[data-v-c036f05a] .el-dialog__body{padding:24px 28px 28px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4809:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-panel',[_c('template',{slot:"header"},[_vm._v("2. 分配给复核人")]),_vm._v(" "),_c('div',{staticClass:"assign-diff-bar"},[_c('span',{staticClass:"assign-diff-item"},[_vm._v("预计单量合计："),_c('strong',[_vm._v(_vm._s(_vm.totalExpected))])]),_vm._v(" "),_c('span',{staticClass:"assign-diff-item"},[_vm._v("实际分配合计："),_c('strong',[_vm._v(_vm._s(_vm.totalAssignedCount))])]),_vm._v(" "),_c('span',{staticClass:"assign-diff-item"},[_vm._v("差额："),_c('strong',[_vm._v(_vm._s(_vm.assignDiffDisplay))])]),_vm._v(" "),(_vm.assignDiff === 0)?_c('el-tag',{attrs:{"type":"success","size":"small"}},[_vm._v("可分配")]):(_vm.assignDiff < 0)?_c('el-tag',{attrs:{"type":"warning","size":"small"}},[_vm._v("尚余 "+_vm._s(-_vm.assignDiff)+" 单未分配")]):_c('el-tag',{attrs:{"type":"danger","size":"small"}},[_vm._v("超出预计 "+_vm._s(_vm.assignDiff)+" 单")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.reviewerList,"stripe":"","border":""}},[_c('el-table-column',{attrs:{"prop":"name","label":"复核人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.reviewTargetColumnLabel,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.target != null && scope.row.target !== '' ? scope.row.target + '单' : '-')+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":("复核单量(总计" + _vm.totalAssignedCount + ")"),"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"type":"number","size":"small","min":"0","step":"1"},on:{"input":function($event){return _vm.onReviewerAssignedChange(scope.row)}},model:{value:(scope.row.assignedCount),callback:function ($$v) {_vm.$set(scope.row, "assignedCount", $$v)},expression:"scope.row.assignedCount"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.removeReviewer(scope.$index)}}},[_vm._v("移除")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"margin t15 reviewer-toolbar"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":_vm.openAddReviewerDialog}},[_vm._v("添加复核人")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","icon":"el-icon-s-operation","disabled":_vm.reviewerList.length === 0},on:{"click":_vm.applyAverageDistribution}},[_vm._v("一键平均复核单量")])],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"选择复核人","visible":_vm.addReviewerDialogVisible,"width":"720px","custom-class":"add-reviewer-dialog"},on:{"update:visible":function($event){_vm.addReviewerDialogVisible=$event},"open":_vm.onAddReviewerDialogOpen,"closed":_vm.onAddReviewerDialogClosed}},[_c('el-form',{attrs:{"label-width":"110px"}},[_c('el-form-item',{attrs:{"label":"选择复核人："}},[_c('remote-select',{staticClass:"dialog-select-width",attrs:{"clearable":"","multiple":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入用户名称搜索","query-request":_vm.queryPlatformUsers,"find-request":_vm.findPlatformUser},model:{value:(_vm.selectedReviewerInDialog),callback:function ($$v) {_vm.selectedReviewerInDialog=$$v},expression:"selectedReviewerInDialog"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.addReviewerDialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirmAddReviewer}},[_vm._v("确定")])],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4810:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"assign-review-page"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("任务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('TaskDescButton')],1)],1),_vm._v(" "),_c('div',{staticClass:"quick-actions"},[_c('span',{staticClass:"quick-label"},[_vm._v("将所有实习生抽检比例设置为")]),_vm._v(" "),_c('el-input',{staticClass:"quick-input quick-input-rate",attrs:{"type":"number","placeholder":"","min":"0","max":"100","step":"1"},on:{"input":_vm.onQuickSampleRateInput},model:{value:(_vm.quickForm.sampleRate),callback:function ($$v) {_vm.$set(_vm.quickForm, "sampleRate", $$v)},expression:"quickForm.sampleRate"}},[_c('template',{slot:"append"},[_vm._v("%")])],2),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.applyQuickSettings}},[_vm._v("应用")])],1),_vm._v(" "),_c('source-allocation-panel',{ref:"sourcePanel",attrs:{"query-params":_vm.$route.query},on:{"total-expected":function($event){_vm.totalExpected = $event}}}),_vm._v(" "),_c('reviewer-assign-panel',{ref:"reviewerPanel",attrs:{"total-expected":_vm.totalExpected,"review-target-date":_vm.reviewTargetDate}}),_vm._v(" "),_c('div',{staticClass:"page-actions"},[_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.submitting},on:{"click":_vm.onConfirmAssign}},[_vm._v("确认分配")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/order-assign-review.75015ddc45bfee794171.js